import { getSpinWheelTemplate, getVueSpinWheelTemplate } from "../../shortcodes/templates";

let spinWheel = null;
const visualizeSpinWheel = content => {
  spinWheel = content.querySelectorAll('[data-wrapper-id="spin-wheel"]');
  if (spinWheel.length > 0) {
    spinWheel.forEach(item => {
      item.innerHTML = getSpinWheelTemplate();
    });
  }
};

const serializeSpinWheel = content => {
  const spinWheelWidget = content.querySelectorAll('[data-wrapper-id="spin-wheel"]');
  if (spinWheelWidget.length > 0) {
    spinWheelWidget.forEach(item => {
      const spinWheelData = item.getAttribute("data-spin-wheel-data");
      item.innerHTML = getVueSpinWheelTemplate(spinWheelData);
    });
  }
};

export { visualizeSpinWheel, serializeSpinWheel };
